import ReactQuill from 'react-quill';

/**
 * Создаёт конфигурацию Quill modules с кастомными кнопками «Телефон» и «Email».
 * Использование: передать quillRef для доступа к editor instance.
 */
export function getQuillModules(quillRef: React.RefObject<ReactQuill | null>) {
  return {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'link'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['phone', 'email'],
      ],
      handlers: {
        phone: () => {
          const editor = quillRef.current?.getEditor();
          if (!editor) return;

          const phone = prompt('Введите номер телефона (например: +7 999 123 4567):');
          if (!phone) return;

          const cleanPhone = phone.replace(/[^\d+]/g, '');
          const range = editor.getSelection(true);
          const displayText = phone;

          editor.insertText(range.index, displayText, 'link', `tel:${cleanPhone}`);
          editor.setSelection(range.index + displayText.length, 0);
        },
        email: () => {
          const editor = quillRef.current?.getEditor();
          if (!editor) return;

          const emailAddr = prompt('Введите email адрес:');
          if (!emailAddr) return;

          const range = editor.getSelection(true);
          editor.insertText(range.index, emailAddr, 'link', `mailto:${emailAddr}`);
          editor.setSelection(range.index + emailAddr.length, 0);
        },
      },
    },
  };
}
